import { render, staticRenderFns } from "./AddCourseFAQ.vue?vue&type=template&id=57b84252&scoped=true&"
import script from "./AddCourseFAQ.vue?vue&type=script&lang=js&"
export * from "./AddCourseFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b84252",
  null
  
)

export default component.exports